























































































import tableModal from '../components/TableModal.vue'
import { openLinkInBrowser } from '../mla-shared';

export default {
  props: {
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: false
    },
    minFieldWidths: {
      type: String,
      required: false,
      default: '25vw'
    },
    theaders: {
      type: Array,
      default: () => [],
      required: true
    },
    tdata: {
      type: Array,
      default: () => [],
      required: true
    }
  },

  data () {
    return {
      openLinkInBrowser: openLinkInBrowser
    }
  },

  methods: {
    // Toggle optional rows
    toggle: function (this:any, category:any) {
      this.tdata.forEach((e:any) => {
        if (e.category === category) {
          e.hidden = false
        }
      })
    },
    // Return the updated row to the parent component
    update: function (this:any, row:any) {
      this.$emit('update', row)
    }
  },

  components: { tableModal }
}
